const getApiBasePath = () => '/api';

export default {
    getApiBasePath,
};
